import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  unitMeasurements: [],
  unitMeasurement: null,
  error: null
};

const unitMeasurementsSlice = createSlice({
  name: "unitMeasurements",
  initialState,
  reducers: {
    setUnitsMeasurements: (state, action) => {
      state.unitMeasurements = action.payload;
    },
    setUnitsMeasurement: (state, action) => {
      state.unitMeasurement = action.payload;
    },
    addUnitsMeasurement: (state, action) => {
      state.unitMeasurements.push(action.payload);
    },
    updateUnitsMeasurement: (state, action) => {
      console.log(action.payload);
    },
    removeUnitsMeasurement: (state, action) => {
      state.unitMeasurements = state.unitMeasurements.filter(
        item => item.id !== action.payload.id
      );
    }
  },
  selectors: {
    selectUnitsMeasurement: state => state.unitMeasurement,
    selectUnitsMeasurements: state => state.unitMeasurements
  }
});

export const {
  setUnitsMeasurement,
  setUnitsMeasurements,
  addUnitsMeasurement,
  removeUnitsMeasurement,
  updateUnitsMeasurement
} = unitMeasurementsSlice.actions;

export const {
  selectUnitsMeasurement,
  selectUnitsMeasurements
} = unitMeasurementsSlice.selectors;

export default unitMeasurementsSlice.reducer;
